<!-- 营销中心 平台营销工具 会员卡权益 -->
<template>
  <scroll-layout>
    <template slot="header">
      <ykc-search
        ref="YkcSearch"
        :data="searchData"
        :searchForm="searchParams"
        @click="handleSearchConfirm"
        @clean="handleSearchClean"></ykc-search>
    </template>
    <div>
      <ykc-table
        ref="YkcTable"
        title="电站列表"
        :data="tableData"
        :columns="tableColumns"
        :selectOnIndeterminate="false"
        :rowSelectable="row => Number(row.type) === 1"
        :operateButtons="tableOperateButtons.filter(item => item.enabled())"
        @selection-change="selectionChange">
        <ykc-pagination
          slot="pagination"
          ref="YkcPagination"
          :total="pageInfo.total"
          :current-page.sync="pageInfo.pageIndex"
          :page-size.sync="pageInfo.pageSize"
          @current-change="handlePaginationCurrentChange"
          @size-change="handlePaginationSizeChange"></ykc-pagination>
      </ykc-table>
    </div>
    <ykc-drawer
      :show.sync="showDrawer"
      size="1020px"
      title="会员卡权益"
      :on-close="onAddDrawerClose"
      :before-cancel="onAddDrawerCancel">
      <template #footer>
        <div class="drawer-button-wrap">
          <template v-for="(btn, i) in drawerButtons">
            <ykc-button
              style="margin-left: 8px"
              :type="btn.type"
              v-if="btn.enabled()"
              :key="i"
              @click="btn.handler">
              {{ btn.label }}
            </ykc-button>
          </template>
        </div>
      </template>
      <div class="drawer-main-body" v-if="showDrawer">
        <AddOrEdit
          ref="addOrEdit"
          :currentRow="currentRow"
          :operateType="operateType"
          :selectedRows="selectedRows"></AddOrEdit>
      </div>
    </ykc-drawer>
  </scroll-layout>
</template>

<script>
  import YkcDialog from '@/components/ykc-ui/dialog';
  import AddOrEdit from './AddOrEdit.vue';
  import { chargeVipPriceFee, directPage } from '@/service/apis';
  import { code } from '@/utils';

  export default {
    name: 'memberCardEquityList',
    components: {
      AddOrEdit,
    },
    data() {
      return {
        showDrawer: false,
        operateType: '',
        selectedRows: [],
        currentRow: null,
        drawerButtons: [
          {
            label: '取消',
            type: 'plain',
            enabled: () => true,
            handler: () => {
              YkcDialog({
                dialogType: 'feedback',
                showTitle: false,
                showFooter: true,
                desc: '取消后操作将不被保存，确认是否取消',
                onCancel: dialogDone => {
                  dialogDone(); // 隐藏弹窗
                },
                onConfirm: dialogDone => {
                  dialogDone(); // 隐藏弹窗
                  this.showDrawer = false; // 隐藏抽屉
                },
              });
            },
          },
          {
            label: '保存',
            enabled: () => true,
            handler: () => {
              this.$refs.addOrEdit.submitForm(() => {
                this.showDrawer = false;
                this.searchTableList();
              });
            },
          },
        ],
        tableData: [],
        tableOperateButtons: [
          {
            enabled: () => code('marketing:membercard:equity:edit'),
            render: (h, button, { row }) => {
              return (
                <ykc-button
                  type="text"
                  class="do-enable-btn"
                  onClick={() => {
                    this.doEdit(row);
                  }}>
                  编辑
                </ykc-button>
              );
            },
          },
          {
            enabled: () => code('marketing:membercard:equity:detail'),
            render: (h, button, { row }) => {
              // 未配置无详情
              if (String(row.isConfig) === 0) {
                return null;
              }
              return (
                <ykc-button
                  type="text"
                  class="do-enable-btn"
                  onClick={() => {
                    this.doDetail(row);
                  }}>
                  详情
                </ykc-button>
              );
            },
          },
          {
            enabled: () => code('marketing:membercard:order:list'),
            render: (h, button, { row }) => {
              return (
                <ykc-button
                  type="text"
                  class="do-enable-btn"
                  onClick={() => {
                    this.handleViewOrders(row);
                  }}>
                  订单列表
                </ykc-button>
              );
            },
          },
        ],
        tableColumns: [
          { label: '电站编码', prop: 'stationCode', minWidth: '200px' },
          {
            label: '电站名称',
            prop: 'stationName',
            minWidth: '200px',
            // scopedSlots: {
            //   default: ({ row }) => {
            //     return (
            //       <el-badge
            //         value={row.usedType && Number(row.usedType) ? '待生效' : ''}
            //         type="primary">
            //         <el-tooltip effect="dark" content={row.stationName} placement="top-start">
            //           <span>{row.stationName ?? '--'}</span>
            //         </el-tooltip>
            //       </el-badge>
            //     );
            //   },
            // },
          },
          {
            label: '归属商家',
            prop: 'operatorName',
            minWidth: '200px',
            // scopedSlots: {
            //   default: ({ row }) => {
            //     return (
            //       <el-tooltip effect="dark" content={row.stationOperatorName} placement="top-start">
            //         <span>{row.stationOperatorName}</span>
            //       </el-tooltip>
            //     );
            //   },
            // },
          },
          {
            label: '直联互联',
            prop: 'type',
            minWidth: '200px',
          },
          {
            label: '状态',
            prop: 'isConfig',
            scopedSlots: {
              defaultTitle: () => '',
              default: ({ row: { isConfig } }) => {
                return (
                  {
                    0: '未配置',
                    1: '已配置',
                  }[isConfig] || '一'
                );
              },
            },
          },
          { label: '修改人', prop: 'modifiedBy' },
          { label: '修改时间', prop: 'modifiedTime', minWidth: '200px' },
        ],
        pageInfo: {
          total: 0,
          pageIndex: 1,
          pageSize: 10,
        },
        searchParams: {
          stationName: null,
          stationCode: null,
          isConfig: null,
          type: '',
          operatorId: '',
        },
        OperatorListData: [],
      };
    },
    computed: {
      searchData() {
        return [
          {
            comName: 'YkcInput',
            key: 'stationCode',
            label: '电站编码',
            placeholder: '请输入电站编码',
          },
          {
            comName: 'YkcInput',
            key: 'stationName',
            label: '电站名称',
            placeholder: '请输入电站名称',
          },
          {
            comName: 'YkcDropdown',
            key: 'operatorId',
            label: '归属商家',
            placeholder: '请输入归属商家',
            data: this.OperatorListData,
            remote: true,
          },
          {
            comName: 'YkcDropdown',
            key: 'isConfig',
            label: '状态',
            placeholder: '请选择状态',
            data: [
              {
                id: null,
                name: '全部',
              },
              {
                id: 0,
                name: '未配置',
              },
              {
                id: 1,
                name: '已配置',
              },
            ],
          },
          {
            comName: 'YkcDropdown',
            key: 'type',
            label: '直联互联',
            placeholder: '请输入直联互联',
            data: [
              {
                id: '',
                name: '全部',
              },
              {
                id: '1',
                name: '直联',
              },
              {
                id: '2',
                name: '互联',
              },
            ],
          },
        ];
      },
    },
    created() {
      if (this.$route.query.stationName) {
        this.searchParams.stationName = this.$route.query.stationName;
      }

      this.searchTableList();
      this.requestOperatorList();
    },
    methods: {
      requestOperatorList() {
        directPage.userOperatorList({ keyword: '' }).then(res => {
          // eslint-disable-next-line no-unused-vars
          this.OperatorListData = (res || []).map(({ operatorId, name }) => ({
            name,
            id: String(operatorId),
          }));
        });
      },
      doEdit(row) {
        if (row.isSetPrice === 0) {
          this.$message.error('请先操作配置价格策略');
        } else {
          const { stationId } = row;
          const commId = stationId;
          chargeVipPriceFee.detail({ id: commId }).then(data => {
            this.operateType = 'single';
            this.currentRow = {
              ...row,
              ...(data || {}),
            };
            this.showDrawer = true;
          });
        }
      },
      handleBatchSet(key) {
        switch (key) {
          // 批量设置
          case 'batchSetting':
            if (this.selectedRows.length > 0) {
              this.operateType = 'multiple';
              this.showDrawer = true;
            } else {
              this.$message.warning('请选择数据');
            }
            break;
          // 价格模板
          case 'priceTemplate':
            this.$router.push({
              path: '/operationCenter/priceManage/chargingPriceTemplate',
              query: {},
            });
            break;

          default:
            break;
        }
      },
      doDetail({ stationId }) {
        this.$router.push({
          path: '/marketingCenter/platformMarketingTools/memberCardEquity/detail',
          query: {
            stationId,
          },
        });
      },
      searchTableList() {
        const data = {
          ...this.searchParams,
          size: this.pageInfo.pageSize,
          current: this.pageInfo.pageIndex,
        };
        chargeVipPriceFee.queryForPage(data).then(res => {
          this.tableData = res.records;
          this.pageInfo.total = res.total;
          this.pageInfo.pageIndex = res.current;
        });
      },

      /** 点击清空查询按钮 */
      handleSearchClean(form) {
        Object.assign(this.searchParams, form);
      },

      /** 点击查询按钮 */
      handleSearchConfirm() {
        this.pageInfo.pageIndex = 1;
        this.searchTableList();
      },
      onAddDrawerClose(done) {
        done();
      },
      /** 分页 change 事件监听器 */
      handlePaginationCurrentChange(current) {
        this.pageInfo.pageIndex = current;
        this.searchTableList();
      },
      /** 点击抽屉取消按钮 callback */
      onAddDrawerCancel(drawerDone) {
        YkcDialog({
          dialogType: 'feedback',
          showTitle: false,
          showFooter: true,
          desc: '取消后操作将不被保存，确认是否取消',
          onCancel: done => {
            done();
          },
          onConfirm: done => {
            done();
            drawerDone();
            // 点击确认取消保存后，要重置表单
            if (this.isEdit) {
              this.isEdit = false;
            }
          },
        });
      },
      /** 分页 size  change  事件监听器 */
      handlePaginationSizeChange(size) {
        this.pageInfo.pageIndex = 1;
        this.pageInfo.pageSize = size;
        this.searchTableList();
      },
      /** 获取勾选id */
      selectionChange(selection) {
        this.selectedRows = [...selection];
      },
      handleViewOrders(row) {
        this.$router.push({
          path: '/marketingCenter/platformMarketingTools/memberCardEquity/orderList',
          query: {
            stationId: row.stationId,
          },
        });
      },
    },
  };
</script>

<style lang="scss">
  .el-badge__content.is-fixed {
    position: absolute;
    top: 10px;
    right: -8px;
    -webkit-transform: translateY(-50%) translateX(100%);
    transform: translateY(-50%) translateX(100%);
  }
</style>
